import { createContext } from 'react';

export interface RhinoErrorReporter {
  report: (error: unknown, context?: Record<string, unknown>) => void;
}

// Default reporter so components work without a provider (e.g. tests, bare
// installs) — errors still surface in the console instead of vanishing.
export const defaultRhinoErrorReporter: RhinoErrorReporter = {
  report: (error) => console.error(error)
};

export const RhinoErrorReporterContext = createContext<RhinoErrorReporter>(
  defaultRhinoErrorReporter
);
